<div class="content-container flex-column">
    <div class="header-padding">
		<div class="header-container">
			<div class="report-info">
				<h2 class="report-title">Database</h2>
				<p class="report-subtitle">
					<span class="subtitle-span">Drill & Blast Collection</span> - visualizes
				</p>
			</div>
            <mat-form-field class="drill-search" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput #searchInput [value]="search" placeholder="Search by project name" (keyup)="applyFilter(searchInput.value)">
            </mat-form-field>
			<div class="actions-container flex-row">
                <div class="filter" [matTooltip]="'Filter'" (click)="showModal = !showModal;$event.stopPropagation()">
                    <mat-icon>
                        filter_list
                    </mat-icon>
                </div>
                <div *ngIf="showModal" >
                    <mat-card class="filter-card">
                        <mat-card-header class="flex-row card-header">
                            <mat-card-title>
                                <div class="flex-row gap-large">
                                    <h3>
                                        Filter Options
                                    </h3>
                                    <mat-icon class="close-btn" [matTooltip]="'Close'" (click)="showModal =! showModal">
                                        close
                                    </mat-icon>
                                </div>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content (click)="$event.stopPropagation()">
                            <div class="filter-container flex-column gap-small">
                                <mat-checkbox *ngFor="let data of filterValues"
                                    [(ngModel)]="data.value"
                                    color="primary"
                                    (change)="onApplyFilter()"
                                >
                                    {{data.name}}
                                </mat-checkbox>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
			<div class="export-btn">
                <button mat-button class="import-btn secondary" (click)="importAsExcel()">
                    <mat-icon svgIcon="importIcon" class="svg-icon"></mat-icon>
                    Import as Excel
                </button>

                <input  type="file" #fileInput style="display: none" (change)="onFileChange($event)" />

                <button mat-button class="import-btn secondary" (click)="downloadToExcel('exportExcel')">
                    <mat-icon svgIcon="exportIcon" class="svg-icon"></mat-icon>
                    Export as Excel
                </button>

                <button mat-button class="primary export-pdf-btn cta" (click)="downloadToExcel('downloadSample')">
                    <mat-icon svgIcon="downloadSampleIcon" class="svg-icon"></mat-icon>
                    Download Sample
                </button>
			</div>
		</div>
	</div>
    <div class="chart-wrapper">
        <div class="table-container">
            <table class="data mat-elevation-z1 excel-table" mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="datasetName" sticky>
                    <th mat-header-cell *matHeaderCellDef>Project</th>
                    <td mat-cell *matCellDef="let element" #cell>
                        <mat-select  *ngIf="!element.isRecordExist && !element.apiV2DatasetId" [(ngModel)]="selectedDataset" (selectionChange)="onDatasetSelect($event)">
                            <mat-option *ngFor="let dataset of datasetNames" [value]="dataset">{{ dataset.blast }}</mat-option>
                        </mat-select>
                        <span class="xs-display" *ngIf="element.isRecordExist || element.apiV2DatasetId">{{element.blast}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="blastReportUrl">
                    <th mat-header-cell *matHeaderCellDef>Blast Report URL</th>
                    <td mat-cell *matCellDef="let element">
                        <input type="text" matInput [(ngModel)]="element.blastReportUrl" *ngIf="!element.isRecordExist && !element.apiV2DatasetId" />
                        <a class="xs-display" [href]="element.blastReportUrl" target="_blank" *ngIf="element.isRecordExist || element.apiV2DatasetId">{{element.blastReportUrl}}</a>
                    </td>
                </ng-container>

				<ng-container *ngFor="let col of dataSourceSchema">
					<ng-container *ngIf="getDisplayedColumns().includes(col.key)" [matColumnDef]="col.key">
						<th mat-header-cell *matHeaderCellDef>
							{{ col.label == 'Average Charge' ? (col.label | UnitDisplayPipe : userUnitMeasurement : col.valueUnit) + '/hole' : (col.label | UnitDisplayPipe : userUnitMeasurement : col.valueUnit) }}
						</th>

						<td mat-cell *matCellDef="let element">
							<ng-container *ngIf="col.key === 'videoUrls'; else defaultDataCell">
								<ng-container *ngIf="getVideoUrls(element) as videoUrls">
									<div class="video-links-cell flex-row center" *ngIf="videoUrls.length; else noVideos">
										<button type="button" class="video-menu-trigger flex-row items-center center gap-small" [matMenuTriggerFor]="videoMenu">
											<mat-icon>play_circle</mat-icon>
											<span class="video-trigger-label">{{ videoUrls.length }} Video(s)</span>
											<mat-icon>expand_more</mat-icon>
										</button>
										<mat-menu #videoMenu="matMenu" class="video-links-menu">
											<div class="video-menu-title">Blast Videos</div>
											<div class="video-menu-item" *ngFor="let videoUrl of videoUrls; let videoIndex = index" (click)="$event.stopPropagation()">
												<mat-icon class="video-file-icon">movie</mat-icon>
												<div class="video-name" [matTooltip]="getVideoFileName(videoUrl)">
													{{ getVideoFileName(videoUrl) || 'Video ' + (videoIndex + 1) + '.mp4' }}
												</div>
													<button type="button" class="video-download-button" mat-icon-button (click)="downloadVideo(videoUrl)" matTooltip="Download video">
														<mat-icon>download</mat-icon>
													</button>
											</div>
										</mat-menu>
									</div>
									<ng-template #noVideos>
										<span class="no-video-links">No videos</span>
									</ng-template>
								</ng-container>
							</ng-container>
							<ng-template #defaultDataCell>
								<input [type]="col.type" matInput [ngModel]="element[col.key] | UnitConversionPipe : userUnitMeasurement : col.valueUnit"
									readonly="true"
									(focus)="onFieldInputClick($event, col, element)"
									[required]="col.required"
									(ngModelChange)="onFieldInputChange(element, col.key, $event, col.valueUnit, col.type)"
								/>
							</ng-template>
						</td>
					</ng-container>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"></tr>

			</table>
		</div>
	</div>
    
    <div class="actions-button-container flex-row items-center">
        <div class="actions-button flex-row items-center" *ngIf="domainId">
            <button
                mat-button
                class="add-row primary cta"
                (click)="onSaveOrAddRow()"
            ><mat-icon svgIcon="addIcon" class="svg-icon"></mat-icon>
                {{ isNewRow ? "Save" : "Add Row" }}
            </button>
            <button
                mat-button
                *ngIf="isNewRow"
                class="add-row primary cta"
                (click)="removeRow()"
            >
                Remove
            </button>
        </div>
        <mat-paginator
            [length]="totalCount"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="[30, 40]"
            (page)="onPageChange($event)"
        >
        </mat-paginator>
    </div>
</div>

<div class="loading-container" *ngIf="loadingDrillData">
    <mat-spinner matTooltip="Loading Drill Data Collection View"></mat-spinner>
</div>
